module.exports = __webpack_public_path__ + "static/media/5-3.80586488.mp3";